import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Buffer } from "./Buffer";
import { PartnerBuffer } from "./pages/PartnerBuffer";

import { PREVIOUS_STORAGE_URL_KEY } from "./helpers";

function App() {
  useEffect(() => {
    localStorage.setItem(PREVIOUS_STORAGE_URL_KEY, document.referrer);

    return () => {
      localStorage.removeItem(PREVIOUS_STORAGE_URL_KEY);
    };
  });

  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="items/appointment/:freetrialride" element={<Buffer />} /> */}
        <Route path="items/appointment/:freetrialride" element={<PartnerBuffer />} />
        <Route path="items/rent/:category/:group" element={<Buffer />} />
        <Route path="items/rent/:transport" element={<Buffer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
